import type { CardHooks } from "./registry";

/**
 * Fleeting Cut — full block: next block gains +1 block (data-driven mechanic
 * already covers this). Counter grants Reflect 2 to next defend.
 * The hook here is a no-op placeholder for future custom logic.
 */
export const fleetingCut: CardHooks = {};
